/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectCurrentUser, selectIsCurrentUserLoading } from '../slice/selectors';
import { usePortalSlice } from '../slice';

export default function useGetCurrentUser() {
  const dispatch = useDispatch();
  const currentUser = useSelector(selectCurrentUser);
  const isCurrentUserLoading = useSelector(selectIsCurrentUserLoading);
  const { actions } = usePortalSlice();
  const getCurrentUser = useCallback(() => {
    dispatch(actions.getCurrentUser());
  }, []);
  useEffect(() => {
    getCurrentUser();
  }, [getCurrentUser]);
  return { currentUser, isCurrentUserLoading };
}
